'use client';

import ButtonGradient from "@/components/ButtonGradient";
import { staticUrl } from "@/libs/cdn";
import fluentCityImg from "@/public/blog2/article3/fr.jpg";
import Image from "next/image";
import type React from "react";
import { styles } from "../_assets/content";

const Article3: React.FC = () => {
  return (
    <>
      <Image
        src={fluentCityImg}
        alt=""
        width={700}
        height={500}
        priority={true}
        className="rounded-box"
        // placeholder="blur"
      />
      <section>
        <h3 className={styles.h3}>Pourquoi se préparer spécifiquement pour le DELF et le DALF ?</h3>
        <p className={styles.p}>
          Les examens DELF et DALF certifient votre maîtrise du français sur différentes compétences – compréhension orale et écrite, production orale et écrite. Ces examens sont divisés en niveaux de difficulté, du DELF A1 (débutant) au DALF C2 (niveau avancé). Chaque niveau correspond à des compétences spécifiques et répond à des besoins particuliers. Le DELF et le DALF sont reconnus par les universités, les employeurs et les institutions dans de nombreux pays. Une bonne préparation est donc indispensable pour réussir.
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Télécharge ton cahier d'exercices gratuit</h3>
        <p className={styles.p}>
          Préparer un examen de langue demande de la persévérance, mais avec une bonne organisation et des ressources adaptées, vous pouvez atteindre votre objectif.<br/> Téléchargez le workbook B1 sur Linpoly.com pour un entraînement efficace, et n'oubliez pas de rester régulier dans votre apprentissage. La réussite est à portée de main !
        </p>
        <p className="mt-10">
        <ButtonGradient 
          title="kostenlose herunterladen" 
          onClick={() => {
            const link = document.createElement('a');
            link.href = staticUrl("/workbooks/Linpoly-French-Workbook-B1.pdf");
            link.setAttribute('download', 'Linpoly-French-Workbook-B1.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }} 
        />
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Plus de pratique – Plus de succès</h3>
        <p className={styles.p}>
          Téléchargez votre livre d'exercices DELF/DALF gratuit dès aujourd'hui et commencez votre préparation !
        </p>
      </section>
    </>
  );
};

export default Article3;